import React from 'react';

const PortfolioSection: React.FC = () => {
  return (
    <section className="py-16 sm:py-18 lg:py-20 bg-[#FAF7F1]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* ================= Heading ================= */}
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900">
            Expert Architectural Services for Every Need in Varanasi
          </h2>

          <p className="mt-4 text-sm sm:text-base text-gray-600 max-w-3xl mx-auto">
            Explore the diverse range of architecture and interior design services in Varanasi that we offer:
          </p>

          <div className="mt-6 border-t border-dotted border-gray-400 w-2/3 mx-auto" />
        </div>

        {/* ================= Services Grid ================= */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">

          {/* ================= Card 1 ================= */}
          <div className="bg-white rounded shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col">
            <div className="p-6 sm:p-8 flex-1">
              <div className="text-4xl sm:text-5xl mb-4 text-gray-800">
                🏗️
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">
                Architecture Design
              </h3>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Elevate your property with the expertise of the <strong>best architect in Varanasi.</strong>{' '}
                We create custom architectural designs that are both innovative and practical.
                Whether it’s a residential or commercial project, we turn your ideas into reality
                with detailed, creative plans.
              </p>
            </div>
            <div className="bg-gray-900 text-white text-center py-3 font-medium cursor-pointer hover:bg-gray-800 transition-colors">
              LEARN MORE →
            </div>
          </div>

          {/* ================= Card 2 ================= */}
          <div className="bg-yellow-400 rounded shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col">
            <div className="p-6 sm:p-8 flex-1">
              <div className="text-4xl sm:text-5xl mb-4 text-gray-900">
                🎨
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">
                Interior Design
              </h3>
              <p className="text-sm sm:text-base text-gray-900 leading-relaxed">
                Transform your space with the <strong>best interior design in Varanasi.</strong>{' '}
                Our talented <strong>interior designers</strong> craft bespoke interiors that reflect
                your personal style. From contemporary designs to classic themes, we ensure your
                space is as unique as you are.
              </p>
            </div>
            <div className="bg-gray-900 text-white text-center py-3 font-medium cursor-pointer hover:bg-gray-800 transition-colors">
              LEARN MORE →
            </div>
          </div>

          {/* ================= Card 3 ================= */}
          <div className="bg-white rounded shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col">
            <div className="p-6 sm:p-8 flex-1">
              <div className="text-4xl sm:text-5xl mb-4 text-gray-800">
                📐
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">
                2D & 3D Intrial Designs
              </h3>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                2D & 3D Interior Designs

Transform your spaces with our expert 2D and 3D interior design solutions. We bring your vision to life with precision, creativity, and attention to detail.
              </p>
            </div>
            <div className="bg-gray-900 text-white text-center py-3 font-medium cursor-pointer hover:bg-gray-800 transition-colors">
              LEARN MORE →
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
